import {Injectable} from '@angular/core';
import {RoutingService} from '@spartacus/core';
import {
  CommonConfiguratorUtilsService,
  ConfiguratorRouter,
  ConfiguratorRouterExtractorService,
} from '@spartacus/product-configurator/common';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ExternalAttribute} from '../models';

@Injectable({
  providedIn: 'root',
})
export class DCPConfiguratorRouterExtractorService extends ConfiguratorRouterExtractorService {
  constructor(
    protected override configUtilsService: CommonConfiguratorUtilsService,
    protected override routingService: RoutingService,
  ) {
    super(configUtilsService, routingService);
  }

  private readonly CPS_ATTRIBUTE_PREFIX = 'LIC';

  override extractRouterData(): Observable<ConfiguratorRouter.Data> {
    const originalRouterData = super.extractRouterData();
    return combineLatest([originalRouterData, this.routingService.getRouterState()]).pipe(
      map(([routerData, routerState]) => {
        const externalAttributes = [];
        for (const queryParamsKey in routerState.state.queryParams) {
          if (queryParamsKey.includes(this.CPS_ATTRIBUTE_PREFIX)) {
            const queryParam = routerState.state.queryParams[queryParamsKey];
            const externalAttribute: ExternalAttribute = {
              name: queryParamsKey,
              // When query params are replicated then the value is modeled as array
              value: Array.isArray(queryParam) && queryParam.length > 0 ? queryParam[0] : queryParam,
            };
            externalAttributes.push(externalAttribute);
            routerData.externalAttributes = externalAttributes;
          }
        }
        return routerData;
      }),
    );
  }
}
